module.exports = __webpack_public_path__ + "static/thinking-ape-logo-01267150590eed4f9f5726a67334aec8.png";